/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Api, ApiList, ApiRequestHeader } from '../../data/interfaces';
import {
    FETCH_API_REQUEST, FETCH_API_SUCCESS, FETCH_API_FAILURE,
    FETCH_API_LIST_REQUEST, FETCH_API_LIST_SUCCESS, FETCH_API_LIST_FAILURE,
    FETCH_THUMBNAIL_REQUEST, FETCH_THUMBNAIL_SUCCESS, FETCH_THUMBNAIL_FAILURE,
    FETCH_THUMBNAIL_LIST_REQUEST, FETCH_THUMBNAIL_LIST_SUCCESS, FETCH_THUMBNAIL_LIST_FAILURE, SET_SECURITY_HEADERS, FETCH_MAJOR_VERSION_API_LIST_FAILURE, FETCH_MAJOR_VERSION_API_LIST_REQUEST, FETCH_MAJOR_VERSION_API_LIST_SUCCESS, 
    FETCH_FEATURED_API_LIST_SUCCESS,FEATCH_FEATURED_API_LIST_REQUEST, FETCH_FEATURED_API_LIST_FAILURE
} from '../types/api';

export const fetchApiRequest = () => {
    return {
        type: FETCH_API_REQUEST
    }
}

export const fetchApiSuccess = (api: Api) => {
    return {
        type: FETCH_API_SUCCESS,
        payload: api
    }
}

export const fetchApiFailure = (error: string) => {
    return {
        type: FETCH_API_FAILURE,
        payload: error
    }
}

export const fetchApiListRequest = () => {
    return {
        type: FETCH_API_LIST_REQUEST
    }
}

export const fetchApiListSuccess = (apis: ApiList) => {
    return {
        type: FETCH_API_LIST_SUCCESS,
        payload: apis
    }
}

export const fetchApiListFailure = (error: string) => {
    return {
        type: FETCH_API_LIST_FAILURE,
        payload: error
    }
}

export const fetchFeaturedApiListSuccess = (apis: ApiList) => {
    return {
        type: FETCH_FEATURED_API_LIST_SUCCESS,
        payload: apis
    }
}

export const fetchFeaturedApiListRequest = () => {
    return {
        type: FEATCH_FEATURED_API_LIST_REQUEST
    }
}

export const fetchFeaturedApiListFailure = (error: string) => {
    return {
        type: FETCH_FEATURED_API_LIST_FAILURE,
        payload: error
    }
}

export const fetchMajorVersionApiListRequest = () => {
    return {
        type: FETCH_MAJOR_VERSION_API_LIST_REQUEST
    }
}

export const fetchMajorVersionApiListSuccess = (apis: ApiList) => {
    return {
        type: FETCH_MAJOR_VERSION_API_LIST_SUCCESS,
        payload: apis
    }
}

export const fetchMajorVersionApiListFailure = (error: string) => {
    return {
        type: FETCH_MAJOR_VERSION_API_LIST_FAILURE,
        payload: error
    }
}

export const fetchThumbnailRequest = () => {
    return {
        type: FETCH_THUMBNAIL_REQUEST,
    }
}

export const fetchThumbnailSuccess = (apiThumbnail: Blob) => {
    return {
        type: FETCH_THUMBNAIL_SUCCESS,
        payload: apiThumbnail
    }
}

export const fetchThumbnailFailure = (error: string) => {
    return {
        type: FETCH_THUMBNAIL_FAILURE,
        payload: error
    }
}

export const fetchThumbnailListRequest = () => {
    return {
        type: FETCH_THUMBNAIL_LIST_REQUEST,
    }
}

export const fetchThumbnailListSuccess = (thumbnailMap: { [key: string]: string }) => {
    return {
        type: FETCH_THUMBNAIL_LIST_SUCCESS,
        payload: thumbnailMap
    }
}

export const fetchThumbnailListFailure = (error: string) => {
    return {
        type: FETCH_THUMBNAIL_LIST_FAILURE,
        payload: error
    }
}

export const fetchHeaders = (headers: ApiRequestHeader) => {
    return {
        type: SET_SECURITY_HEADERS,
        payload: headers
    }
}
